/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Complete_Select_SolutionInputs */

const en_task_complete_select_solution = /** @type {(inputs: Task_Complete_Select_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a solution before completing this task.`)
};

const pt_br2_task_complete_select_solution = /** @type {(inputs: Task_Complete_Select_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma solução antes de concluir esta atividade.`)
};

/**
* | output |
* | --- |
* | "Select a solution before completing this task." |
*
* @param {Task_Complete_Select_SolutionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_select_solution = /** @type {((inputs?: Task_Complete_Select_SolutionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Select_SolutionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_select_solution(inputs)
	return pt_br2_task_complete_select_solution(inputs)
});